import { Box, Flex, Icon, Link, Separator, styled, Text } from '@driftt/dds'
import { faQuoteRight } from '@driftt/dds.icons/solid/faQuoteRight'
import { faSparkles } from '@driftt/dds.icons/solid/faSparkles'
import React from 'react'

import { ScenarioExecutionsData } from 'hooks/useScenariosTriggeringPhrases'

const RowContainer = styled(Box, {
  width: '100%',
  padding: '2px',
})

const BaseContainer = styled(Flex, {
  borderRadius: '4px',
  padding: '$2',
  marginTop: '$2',
})

const PurpleContainer = styled(BaseContainer, {
  background: '$purple1',
  border: '1px solid $purple4',
})

const BlueContainer = styled(BaseContainer, {
  background: '$blue1',
  border: '1px solid $blue4',
})

const Phrase = ({
  phraseData,
  divider = false,
}: {
  phraseData: ScenarioExecutionsData
  divider?: boolean
  isAIGenerated?: boolean
}) => {
  return (
    <RowContainer>
      <Flex direction="row" justifyContent="space-between">
        <Link
          href={`/conversations/${phraseData?.conversationId}`}
          variant="inline"
          css={{ cursor: 'pointer' }}
        >
          <Text
            css={{
              color: '$blue8',
              overflowWrap: 'break-word',
              whiteSpace: 'initial',
            }}
          >
            <Icon
              color="gray4"
              icon={faQuoteRight}
              css={{ marginRight: '$1' }}
            />
            {phraseData?.scenarioMessage}
          </Text>
        </Link>
      </Flex>
      {divider && <Separator />}
    </RowContainer>
  )
}

const StaticInput = ({
  phrases,
  aiGeneratedPhrases,
  isAIGenerated,
}: {
  phrases: ScenarioExecutionsData[]
  aiGeneratedPhrases: string[]
  isAIGenerated?: boolean
}) => {
  const Container = isAIGenerated ? PurpleContainer : BlueContainer
  return (
    <Container direction="column" gap={1} alignItems="stretch">
      {isAIGenerated ? (
        <Text variant="bodyBold">
          <Icon color="purple7" icon={faSparkles} css={{ marginRight: '$1' }} />
          Sample phrases that would trigger this scenario
        </Text>
      ) : (
        <Text variant="bodyBold">
          Site visitor messages that have triggered this scenario
        </Text>
      )}
      <Flex
        direction="column"
        gap={0}
        css={{ maxHeight: '150px', overflowY: 'auto' }}
      >
        {isAIGenerated
          ? aiGeneratedPhrases.map((phrase, i) => (
              <RowContainer css={{ borderTop: '1px solid $gray3' }}>
                <Text css={{ color: isAIGenerated ? '$primary' : '$blue8' }}>
                  <Icon
                    color="gray4"
                    icon={faQuoteRight}
                    css={{ marginRight: '$1' }}
                  />
                  {phrase}
                </Text>
              </RowContainer>
            ))
          : phrases.map((phraseData, i) => (
              <Phrase key={i} phraseData={phraseData} divider={i !== -1} />
            ))}
      </Flex>
    </Container>
  )
}

export default StaticInput
